import { Chip } from "@mui/material"

export function TaskReadOnlyHyperlinkChip({ item }) {
    return <Chip size="small" variant="outlined" label={item} />
}
